<template>
  <div class="row badge-min-height rounded align-items-stretch">
    <div
      v-if="showWarningIcon"
      class="col-auto first-col"
      :class="{ 'd-none d-md-block': hideIconOnMobile }"
    >
      <div class="row h-100 align-items-stretch">
        <div class="col align-self-center">
          <SvgIcon icon="WarningIcon" :color="color" center></SvgIcon>
        </div>
      </div>
    </div>
    <div class="col align-self-center px-4">
      <p :class="['mb-0 text-base text-blue-500', { 'fw-bold': boldText }]">
        <slot>{{ text }}</slot>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/widgets/SvgIcon.vue'

interface Props {
  text?: string
  color?: string
  boldText?: boolean
  showWarningIcon?: boolean
  hideIconOnMobile?: boolean
}

withDefaults(defineProps<Props>(), {
  boldText: true,
  showWarningIcon: true,
  hideIconOnMobile: true
})
</script>

<style lang="scss" scoped>
.badge-min-height {
  min-height: 75px;

  .first-col {
    width: 75px;
  }
}
</style>
